import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useInstanceId } from '@wordpress/compose';
import { forwardRef } from '@wordpress/element';
/**
 * Internal dependencies
 */

import Backdrop from './backdrop';
import Label from './label';
import { Container, Root, Prefix, Suffix, LabelWrapper } from './styles/input-control-styles';

function useUniqueId(idProp) {
  var instanceId = useInstanceId(InputBase);
  var id = "input-base-control-".concat(instanceId);
  return idProp || id;
}

export function InputBase(_ref, ref) {
  var __unstableInputWidth = _ref.__unstableInputWidth,
      children = _ref.children,
      className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$hideLabelFromVis = _ref.hideLabelFromVision,
      hideLabelFromVision = _ref$hideLabelFromVis === void 0 ? false : _ref$hideLabelFromVis,
      labelPosition = _ref.labelPosition,
      idProp = _ref.id,
      _ref$isFocused = _ref.isFocused,
      isFocused = _ref$isFocused === void 0 ? false : _ref$isFocused,
      label = _ref.label,
      prefix = _ref.prefix,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      suffix = _ref.suffix,
      props = _objectWithoutProperties(_ref, ["__unstableInputWidth", "children", "className", "disabled", "hideLabelFromVision", "labelPosition", "id", "isFocused", "label", "prefix", "size", "suffix"]);

  var id = useUniqueId(idProp);
  return createElement(Root, _extends({}, props, {
    className: className,
    isFocused: isFocused,
    labelPosition: labelPosition,
    ref: ref
  }), createElement(LabelWrapper, null, createElement(Label, {
    className: "components-input-control__label",
    hideLabelFromVision: hideLabelFromVision,
    labelPosition: labelPosition,
    htmlFor: id,
    size: size
  }, label)), createElement(Container, {
    __unstableInputWidth: __unstableInputWidth,
    className: "components-input-control__container",
    disabled: disabled,
    isFocused: isFocused,
    labelPosition: labelPosition
  }, prefix && createElement(Prefix, {
    className: "components-input-control__prefix"
  }, prefix), children, suffix && createElement(Suffix, {
    className: "components-input-control__suffix"
  }, suffix), createElement(Backdrop, {
    "aria-hidden": "true",
    disabled: disabled,
    isFocused: isFocused,
    label: label,
    size: size
  })));
}
export default forwardRef(InputBase);
//# sourceMappingURL=input-base.js.map